import { render, staticRenderFns } from "./MovimentacaoEstoque.vue?vue&type=template&id=ae247a4a"
import script from "./MovimentacaoEstoque.vue?vue&type=script&setup=true&lang=js"
export * from "./MovimentacaoEstoque.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports